export var FontFamilyKind;
(function (FontFamilyKind) {
    // Sans Serif
    FontFamilyKind[FontFamilyKind["Arial"] = 1] = "Arial";
    FontFamilyKind[FontFamilyKind["Tahoma"] = 2] = "Tahoma";
    FontFamilyKind[FontFamilyKind["Verdana"] = 3] = "Verdana";
    FontFamilyKind[FontFamilyKind["OpenSans"] = 4] = "OpenSans";
    FontFamilyKind[FontFamilyKind["PTSans"] = 5] = "PTSans";
    FontFamilyKind[FontFamilyKind["Ubuntu"] = 6] = "Ubuntu";
    FontFamilyKind[FontFamilyKind["Roboto"] = 7] = "Roboto";
    FontFamilyKind[FontFamilyKind["NotoSans"] = 8] = "NotoSans";
    FontFamilyKind[FontFamilyKind["Lato"] = 9] = "Lato";
    FontFamilyKind[FontFamilyKind["Helvetica"] = 10] = "Helvetica";
    FontFamilyKind[FontFamilyKind["FranklinGothicDemi"] = 11] = "FranklinGothicDemi";
    // Serif
    FontFamilyKind[FontFamilyKind["TimesNewRoman"] = 12] = "TimesNewRoman";
    FontFamilyKind[FontFamilyKind["Georgia"] = 13] = "Georgia";
    FontFamilyKind[FontFamilyKind["Lora"] = 14] = "Lora";
    FontFamilyKind[FontFamilyKind["RobotoSlab"] = 15] = "RobotoSlab";
    FontFamilyKind[FontFamilyKind["PTSerif"] = 16] = "PTSerif";
    FontFamilyKind[FontFamilyKind["NotoSerif"] = 17] = "NotoSerif";
    FontFamilyKind[FontFamilyKind["EBGaramond"] = 18] = "EBGaramond";
})(FontFamilyKind || (FontFamilyKind = {}));
